enum CerberMethods {
  CAPTCHA_GET = 'captcha.get',
  CAPTCHA_VERIFY = 'captcha.verify',
}

export default CerberMethods;
